

import verifyLabel from '../../../../../methods/verifyLabel'

export default {
    name: 'checkout-course-participants',
    props: {
        formRaw: Array,
        displayValidationResult: Function,
        startDisabled: Boolean
    },
    computed: {
        label() {
            return this.$store.state.main.labels
        },
        form(){
            return this.startDisabled ? this.formRaw : this.formRaw
        },
        disableField(){
            return this.startDisabled
        },
        doesContainCourse() {
            return (this.$store.state.cart.courseInfoForCheckout.length)
        }
    },
    methods: {
        verifyLabel(displayName) {
            if (this.$store.state.main.labels) {
                return verifyLabel(displayName, this.$store.state.main.labels)
            } else {
                return ""
            }
        }
    }
}